import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { pluralise } from 'lib/pluralise';
import { theme } from 'lib/theme';
import { union } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { REMOTE_ASESETUP_CHECKLISTITEMDELETE } from 'store/remote/actions';
import {
  selectAseSetupChecklistItemHasActions,
  selectAseSetupChecklistItemHasControls,
  selectAseSetupLibraryChecklistItem,
} from 'store/remote/selectors';

type Props = {
  id: number;
  onPress: () => void;
};

export const ChecklistItemRow: React.FC<Props> = ({ id, onPress }) => {
  const dispatch = useDispatch();

  const checklistItem = useSelector((state) =>
    selectAseSetupLibraryChecklistItem(state, id),
  );

  const actions = useSelector((state) =>
    selectAseSetupChecklistItemHasActions(state, id),
  );

  const controls = useSelector((state) =>
    selectAseSetupChecklistItemHasControls(state, id),
  );

  if (!checklistItem) {
    return null;
  }
  const countActions = union(actions.positive, actions.negative).length;
  const countControls = union(controls.positive, controls.negative).length;

  return (
    <CardRow
      onPress={onPress}
      menuOptions={[
        {
          text: 'Open Checklist Item',
          icon: ICONS.CircleInfoLight,
          onPress,
        },
        {
          text: 'Delete Checklist Item',
          icon: ICONS.TrashCanLight,
          destructive: true,
          onPress: () =>
            dispatch(
              REMOTE_ASESETUP_CHECKLISTITEMDELETE({
                id,
              }),
            ),
        },
      ]}
    >
      <Txt size="small">{checklistItem.text}</Txt>
      {(!!countActions || !!countControls) && (
        <Txt size="xxxsmall" style={{ color: theme.colors.fieldValueText }}>
          {!!countActions && (
            <Txt
              size="xxxsmall"
              style={{ color: theme.colors.assessmentAction }}
            >
              {pluralise(countActions, '1 Action', '{x} Actions', 'No Actions')}
            </Txt>
          )}
          {!!countActions && !!countControls && ' • '}
          {!!countControls && (
            <Txt
              size="xxxsmall"
              style={{ color: theme.colors.assessmentControl }}
            >
              {pluralise(
                countControls,
                '1 Control',
                '{x} Controls',
                'No Controls',
              )}
            </Txt>
          )}
        </Txt>
      )}
    </CardRow>
  );
};
